import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=261baf90&scoped=true&"
import script from "./EventCard.vue?vue&type=script&lang=js&"
export * from "./EventCard.vue?vue&type=script&lang=js&"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=261baf90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261baf90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261baf90')) {
      api.createRecord('261baf90', component.options)
    } else {
      api.reload('261baf90', component.options)
    }
    module.hot.accept("./EventCard.vue?vue&type=template&id=261baf90&scoped=true&", function () {
      api.rerender('261baf90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/EventCard.vue"
export default component.exports